import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'
/* Route */

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/404',
    type: ['allow'],
    component: () =>
      import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    type: ['allow'],
    component: () =>
      import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    type: ['allow'],
    component: () =>
      import('@/views/login/app'),
    hidden: true,
    redirect: '/login'
  },
  {
    path: '/login',
    type: ['allow'],
    component: () =>
      import('@/views/login/app'),
    hidden: true
  },
  {
    path: '/renovationOffer/getOffer/:id',
    type: ['allow'],
    component: () =>
      import('@/views/share/renovationOffer/index'),
    hidden: true,
    name: 'RenovationOfferGetOffer'
  }
]
export const asyncRoutes = [
  // 工作台 workbench.viewWorkBench
  {
    path: '/dashboard',
    redirect: '/dashboard/index',
    isChildren: false,
    component: Layout,
    hidden: false,
    meta: { title: '工作台', icon: 'dashboard', affix: true },
    children: [{
      path: 'index',
      component: () =>
        import('@/views/dashboard/index'),
      name: 'Dashboard',
      hidden: false,
      type: ['workbench.viewWorkBench'],
      meta: { title: '工作台', icon: 'dashboard', affix: true, noCache: true }
    }]
  },
  {
    path: '/task',
    redirect: '/task/index',
    isChildren: false,
    component: Layout,
    hidden: true,
    meta: { title: '任务中心', icon: 'dashboard', noCache: true },
    children: [{
      path: 'index',
      component: () =>
        import('@/views/task/index'),
      name: 'Task',
      hidden: true,
      type: ['bdyCrm.exportCustomers'],
      meta: { title: '任务中心', icon: 'dashboard', noCache: true }
    }]
  },
  {
    path: '/self',
    redirect: '/self/index',
    isChildren: false,
    component: Layout,
    hidden: true,
    meta: { title: '个人中心', icon: 'dashboard', noCache: true },
    children: [{
      path: 'index',
      component: () =>
        import('@/views/self/index'),
      name: 'Self',
      hidden: true,
      type: ['allow'],
      meta: { title: '个人中心', icon: 'dashboard', noCache: true }
    }]
  },
  {
    path: '/message',
    redirect: '/message/message-list',
    isChildren: false,
    component: Layout,
    hidden: true,
    meta: { title: '消息列表', icon: 'dashboard', noCache: true },
    children: [{
      path: 'message-list',
      component: () =>
        import('@/views/message/message-list'),
      name: 'MessageList',
      hidden: true,
      type: ['bdyCrm.viewBDCrm'],
      meta: { title: '消息列表', icon: 'dashboard', noCache: true }
    }]
  },
  {
    path: '/opportunity',
    redirect: '/opportunity/index',
    isChildren: false,
    component: Layout,
    hidden: false,
    meta: { title: '公司商机', icon: 'dashboard', noCache: true },
    children: [{
      path: 'index',
      component: () =>
        import('@/views/opportunity/index'),
      name: 'Opportunity',
      hidden: false,
      type: ['business.viewBusiness'],
      meta: { title: '公司商机', icon: 'dashboard', noCache: true }
    },
    {
      path: 'addOpportunity',
      component: () =>
        import('@/views/opportunity/addOpportunity'),
      name: 'AddOpportunity',
      hidden: true,
      type: ['business.viewBusiness'],
      meta: { title: '新增商机', icon: 'dashboard', noCache: true }
    },
    {
      path: 'recycle',
      component: () =>
        import('@/views/opportunity/recycle'),
      name: 'Recycle',
      hidden: true,
      type: ['business.viewBusiness'],
      meta: { title: '回收站', icon: 'dashboard', noCache: true }
    }
    ]
  },
  {
    path: '/punctuation',
    redirect: '/punctuation/index',
    isChildren: true,
    alwaysShow: false,
    component: Layout,
    hidden: false,
    meta: { title: '标点云CRM', icon: 'shopping-bag', noCache: true },
    children: [{
      path: 'work',
      component: () =>
        import('@/views/data/work'),
      name: 'Work',
      hidden: false,
      type: ['bdyCrm.workBoard'],
      meta: { title: '工作看板', icon: 'dashboard', noCache: true }
    },
    {
      path: 'sale',
      component: () =>
        import('@/views/data/sale'),
      name: 'Sale',
      hidden: false,
      type: ['bdyCrm.saleBoard'],
      meta: { title: '销售看板', icon: 'dashboard', noCache: true }
    },
    {
      path: 'total-data',
      component: () =>
        import('@/views/data/total-data'),
      name: 'TotalData',
      hidden: false,
      type: ['bdyCrm.achievementBoard'],
      meta: { title: '业绩数据', icon: 'dashboard', noCache: true }
    },
    {
      path: 'member-data',
      component: () =>
        import('@/views/data/member-data'),
      name: 'MemberData',
      hidden: true,
      type: ['bdyCrm.achievementBoard'],
      meta: { title: '销售数据明细', icon: 'dashboard', noCache: true }
    },
    // {
    //   path: 'punctuation',
    //   component: () => import('@/views/punctuation/punctuation'),
    //   name: 'Punctuation',
    //   hidden: true,
    //   type: ['company.saleBoard'],
    //   meta: { title: '系统新增', icon: 'dashboard', noCache: true }
    // },
    {
      path: 'index',
      component: () =>
        import('@/views/punctuation/index'),
      name: 'AllCustomers',
      hidden: false,
      type: ['bdyCrm.viewAllCustomers'],
      meta: { title: '全部客户', icon: 'dashboard', noCache: true }
    },
    {
      path: 'myClient',
      component: () =>
        import('@/views/punctuation/myClient'),
      name: 'MyClient',
      hidden: false,
      type: ['bdyCrm.viewBDCrm'],
      meta: { title: '我的客户', icon: 'dashboard', noCache: true }
    },
    {
      path: 'addCustomer',
      component: () =>
        import('@/views/punctuation/addCustomer'),
      name: 'AddCustomer',
      hidden: true,
      type: ['bdyCrm.viewBDCrm'],
      meta: { title: '新增客户', icon: 'dashboard', noCache: true }
    },
    {
      path: 'publicCust',
      component: () =>
        import('@/views/punctuation/publicCust'),
      name: 'PublicCust',
      hidden: false,
      type: ['bdyCrm.viewPublicCustomers'],
      meta: { title: '公共客户', icon: 'dashboard', noCache: true }
    },
    {
      path: 'followList',
      component: () =>
        import('@/views/punctuation/followList'),
      name: 'FollowList',
      hidden: false,
      type: ['bdyCrm.viewFollow'],
      meta: { title: '跟进列表', icon: 'dashboard', noCache: true }
    },
    {
      path: 'list',
      component: () =>
        import('@/views/contract_form/list'),
      name: 'ContractFormList',
      hidden: false,
      type: ['bdyCrm.viewContractForm'],
      meta: { title: '签约单列表', icon: 'dashboard', noCache: true }
    },
    {
      path: 'todo',
      component: () =>
        import('@/views/contract_form/todo'),
      name: 'ContractFormTodo',
      hidden: false,
      type: ['bdyCrm.viewContractAgency'],
      meta: { title: '签约单代办', icon: 'dashboard', noCache: true }
    },
    {
      path: 'create',
      component: () =>
        import('@/views/contract_form/create'),
      name: 'ContractFormCreate',
      hidden: true,
      type: ['bdyCrm.saveContractForm'],
      meta: { title: '签约单创建', icon: 'dashboard', noCache: true }
    }, {
      path: 'detail/:id',
      component: () =>
        import('@/views/contract_form/detail'),
      name: 'ContractFormDetail',
      hidden: true,
      type: ['bdyCrm.viewContractForm'],
      meta: { title: '签约单详情', icon: 'dashboard', noCache: true }
    },
    {
      path: 'targetPlan',
      component: () =>
        import('@/views/punctuation/targetPlan'),
      name: 'TargetPlan',
      hidden: false,
      type: ['bdyCrm.viewPublicCustomers'],
      meta: { title: '目标计划设置', icon: 'dashboard', noCache: true }
    },

    {
      path: 'role',
      component: () =>
        import('@/views/contract_form/role'),
      name: 'ContractFormRole',
      hidden: false,
      type: ['bdyCrm.configCrm'],
      meta: { title: '审批权限设置', icon: 'dashboard', noCache: true }
    },
    {
      path: 'customerRule',
      component: () =>
        import('@/views/punctuation/customerRule'),
      name: 'CustomerRule',
      hidden: false,
      type: ['bdyCrm.configCustomers'],
      meta: { title: '客户规则设置', icon: 'dashboard', noCache: true }
    }
    ]
  },
  // 签约单管理
  // {
  //   path: '/contract_form',
  //   redirect: '/contract_form/list',
  //   isChildren: true,
  //   component: Layout,
  //   hidden: false,
  //   meta: { title: '签约单管理', icon: 'dashboard', noCache: true },
  //   children: [
  //     {
  //       path: 'list',
  //       component: () => import('@/views/contract_form/list'),
  //       name: 'ContractFormList',
  //       hidden: false,
  //       type: ['company.saleBoard'],
  //       meta: { title: '签约单列表', icon: 'dashboard', noCache: true }
  //     },
  //     {
  //       path: 'todo',
  //       component: () => import('@/views/contract_form/todo'),
  //       name: 'ContractFormTodo',
  //       hidden: false,
  //       type: ['company.saleBoard'],
  //       meta: { title: '签约单代办', icon: 'dashboard', noCache: true }
  //     },
  //     {
  //       path: 'role',
  //       component: () => import('@/views/contract_form/role'),
  //       name: 'ContractFormRole',
  //       hidden: false,
  //       type: ['company.saleBoard'],
  //       meta: { title: '审批权限设置', icon: 'dashboard', noCache: true }
  //     }, {
  //       path: 'create',
  //       component: () => import('@/views/contract_form/create'),
  //       name: 'ContractFormCreate',
  //       hidden: true,
  //       type: ['company.saleBoard'],
  //       meta: { title: '签约单创建', icon: 'dashboard', noCache: true }
  //     }, {
  //       path: 'detail',
  //       component: () => import('@/views/contract_form/detail'),
  //       name: 'ContractFormDetail',
  //       hidden: true,
  //       type: ['company.saleBoard'],
  //       meta: { title: '签约单详情', icon: 'dashboard', noCache: true }
  //     }
  //   ]
  // },
  // 客户管理 company.viewCompany company.saveCompany company.updateCompany company.deleteCompany
  // {
  //   path: '/company',
  //   redirect: '/company/crm_statistics',
  //   isChildren: true,
  //   component: Layout,
  //   meta: { title: 'CRM', icon: 'shopping-bag', noCache: true },
  //   hidden: false,
  //   children: [{
  //     path: 'crm_statistics',
  //     type: ['company.workBoard'],
  //     hidden: false,
  //     name: 'CrmStatistics',
  //     component: () =>
  //       import('@/views/company/crm_statistics'),
  //     meta: { title: '工作看板', icon: 'shopping-bag', noCache: true }
  //   },
  //   {
  //     path: 'sale_dashboard',
  //     type: ['company.saleBoard'],
  //     hidden: false,
  //     name: 'SaleDashboard',
  //     component: () =>
  //       import('@/views/company/sale_dashboard'),
  //     meta: { title: '销售看板', icon: 'shopping-bag', noCache: true }
  //   },
  //   {
  //     path: 'company_all',
  //     type: ['company.companyAll'],
  //     hidden: false,
  //     name: 'Company',
  //     component: () =>
  //       import('@/views/company/company_all'),
  //     meta: { title: '全部客户', icon: 'shopping-bag', noCache: true }
  //   },
  //   {
  //     path: 'company_my',
  //     type: ['company.viewCompany'],
  //     hidden: false,
  //     name: 'CompanyMy',
  //     component: () =>
  //       import('@/views/company/company_my'),
  //     meta: { title: '我的客户', icon: 'shopping-bag', noCache: true }
  //   },
  //   {
  //     path: 'company_public',
  //     type: ['company.companyOpen'],
  //     hidden: false,
  //     name: 'CompanyPublic',
  //     component: () =>
  //       import('@/views/company/company_public'),
  //     meta: { title: '公共客户', icon: 'shopping-bag', noCache: true }
  //   },
  //   {
  //     path: 'company_follow',
  //     type: ['company.companyFollow'],
  //     hidden: false,
  //     name: 'CompanyFollow',
  //     component: () =>
  //       import('@/views/company/company_follow'),
  //     meta: { title: '跟进记录', icon: 'shopping-bag', noCache: true }
  //   },
  //   {
  //     path: 'crm_targetPlan',
  //     type: ['company.plan.target'],
  //     hidden: false,
  //     name: 'CompanyTargetPlan',
  //     component: () =>
  //       import('@/views/company/crm_targetPlan'),
  //     meta: { title: '目标计划', icon: '', noCache: true }
  //   },
  //   // {
  //   //   path: 'company_detail',
  //   //   type: ['company.viewCompany'],
  //   //   hidden: true,
  //   //   name: 'CompanyDetail',
  //   //   component: () =>
  //   //     import('@/views/company/company_detail'),
  //   //   meta: { title: '客户详情', icon: 'shopping-bag', noCache: true }
  //   // },
  //   {
  //     path: 'company_label',
  //     type: ['company.companyLabel'],
  //     hidden: false,
  //     name: 'CompanyLabel',
  //     component: () =>
  //       import('@/views/company/company_label'),
  //     meta: { title: '标签管理', icon: 'shopping-bag', noCache: true }
  //   },
  //   // {
  //   //   path: 'company_recycle',
  //   //   type: ['company.deleteCompany'],
  //   //   hidden: false,
  //   //   name: 'CompanyRecycle',
  //   //   component: () => import('@/views/company/company_recycle'),
  //   //   meta: { title: '回收站', icon: 'shopping-bag', noCache: true }
  //   // },
  //   {
  //     path: 'company_setting',
  //     type: ['company.configCompany', 'company.jurisdiction.view'],
  //     hidden: false,
  //     name: 'CompanySetting',
  //     component: () =>
  //       import('@/views/company/company_setting'),
  //     meta: { title: '设置', icon: 'shopping-bag', noCache: true }
  //   }
  //   ]
  // },
  // 装企
  {
    path: '/decoration-enterprise',
    redirect: '/decoration-enterprise/project',
    isChildren: true,
    component: Layout,
    hidden: false,
    meta: { title: '装企云', icon: 'component', noCache: false },
    children: [
      {
        path: 'project',
        component: () => import('@/views/decoration-enterprise/project/list'),
        name: 'DecorationEnterPriseProjectList',
        hidden: false,
        type: ['renovation.project.view', 'renovation.project.my'],
        meta: { title: '项目', icon: '', noCache: false }
      },
      {
        path: 'project-detail/:id',
        component: () => import('@/views/decoration-enterprise/project-detail/index'),
        name: 'DecorationEnterPriseProjectDetail',
        hidden: true,
        type: ['renovation.project.view'],
        meta: { title: '项目详情', icon: '', noCache: false }
      },
      {
        path: 'statistics-echarts',
        component: () => import('@/views/decoration-enterprise/statistics-echarts/index'),
        name: 'StatisticsEcharts',
        hidden: false,
        type: ['renovation.project.view', 'renovation.project.my'],
        meta: { title: '统计报表', icon: '', noCache: false }
      },
      {
        path: 'clock-in',
        component: () => import('@/views/decoration-enterprise/clockIn/index'),
        name: 'ClockIn',
        hidden: false,
        type: ['renovation.visitclock.view'],
        meta: { title: '打卡记录', icon: '', noCache: false }
      },
      {
        path: 'global-manager',
        component: () => import('@/views/decoration-enterprise/global-manager/index'),
        name: 'DecorationEnterPriseProjectGlobalManage',
        hidden: false,
        type: ['renovation.setting'],
        meta: { title: '设置', icon: '', noCache: false }
      },
      {
        path: 'editQuote',
        component: () => import('@/views/decoration-enterprise/project-detail/components/tab-quote/editQuote'),
        name: 'EditQuote',
        hidden: true,
        type: ['renovation.project.view'],
        meta: { title: '编辑报价', icon: '', noCache: false }
      },
      {
        path: 'historyQuote',
        component: () => import('@/views/decoration-enterprise/project-detail/components/tab-quote/historyQuote'),
        name: 'HistoryQuote',
        hidden: true,
        type: ['renovation.project.view'],
        meta: { title: '分享记录', icon: '', noCache: false }
      },
      {
        path: 'processTemplate',
        component: () => import('@/views/decoration-enterprise/global-manager/process/processTemplate'),
        name: 'ProcessTemplate',
        hidden: true,
        type: ['renovation.workingprocedure.view'],
        meta: { title: '工序模板', icon: '', noCache: false }
      },
      {
        path: 'addProcessTemplate',
        component: () => import('@/views/decoration-enterprise/global-manager/process/addProcessTemplate'),
        name: 'AddProcessTemplate',
        hidden: true,
        type: ['renovation.workingprocedure.view'],
        meta: { title: '工序模板', icon: '', noCache: false }
      },
      {
        path: 'expenditure-detail/:id',
        component: () => import('@/views/decoration-enterprise/expenditure-detail/index'),
        name: 'ExpenditureDetail',
        hidden: true,
        type: ['renovation.project.view'],
        meta: { title: '支出明细', icon: '', noCache: false }
      },
      {
        path: 'budget-template-list',
        component: () => import('@/views/decoration-enterprise/budget-template-list/index'),
        name: 'BudgetTemplateList',
        hidden: true,
        type: ['renovation.budget.view'],
        meta: { title: '预算模板列表', icon: '', noCache: false }
      },
      {
        path: 'budget-detail',
        component: () => import('@/views/decoration-enterprise/budget-detail/create'),
        name: 'AddBudgetDetail',
        hidden: true,
        type: ['renovation.budget.view'],
        meta: { title: '新增预算模板', icon: '', noCache: false }
      },
      {
        path: 'budget-detail/:id',
        component: () => import('@/views/decoration-enterprise/budget-detail/edit'),
        name: 'EditBudgetDetail',
        hidden: true,
        type: ['renovation.budget.view'],
        meta: { title: '编辑预算模板', icon: '', noCache: false }
      },
      {
        path: 'quote-template-list',
        component: () => import('@/views/decoration-enterprise/quote-template-list/index'),
        name: 'QuoteTemplateList',
        hidden: true,
        type: ['renovation.project.view'],
        meta: { title: '报价列表', icon: '', noCache: false }
      },
      {
        path: 'quote-detail',
        component: () => import('@/views/decoration-enterprise/quote-detail/create'),
        name: 'AddQuoteDetail',
        hidden: true,
        type: ['renovation.offer.view'],
        meta: { title: '新增报价模板', icon: '', noCache: false }
      },
      {
        path: 'quote-detail/:id',
        component: () => import('@/views/decoration-enterprise/quote-detail/edit'),
        name: 'EditQuoteDetail',
        hidden: true,
        type: ['renovation.offer.view'],
        meta: { title: '编辑报价模板', icon: '', noCache: false }
      }
    ]
  },
  // {
  //   path: '/addon-center',
  //   redirect: '/addon-center/index',
  //   isChildren: false,
  //   component: Layout,
  //   hidden: false,
  //   meta: { title: '应用中心', icon: 'application_new', affix: true },
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/addon-center/index'),
  //       name: 'Addon',
  //       hidden: false,
  //       type: ['appcenter.view'],
  //       meta: { title: '应用中心', icon: 'application_new', affix: true }
  //     },
  //     {
  //       path: 'invoice',
  //       component: () => import('@/views/addon-center/invoice'),
  //       name: 'Invoice',
  //       hidden: true,
  //       type: ['appcenter.view'],
  //       meta: { title: '发票管理', icon: 'application_new', affix: true }
  //     }]
  // },

  // 计划 revenue.viewRevenue revenue.saveRevenu revenue.updateRevenue revenue.deleteRevenue revenue.exportRevenue
  {
    path: '/revenue',
    redirect: '/revenue/index',
    isChildren: false,
    component: Layout,
    hidden: false,
    meta: { title: '计划', icon: 'revenue', noCache: true },
    children: [{
      path: 'index',
      component: () =>
        import('@/views/revenue/index'),
      name: 'Revenue',
      hidden: false,
      type: ['revenue.viewRevenue'],
      meta: { title: '计划', icon: 'revenue', noCache: true }
    },
    {
      path: 'view_revenue',
      component: () =>
        import('@/views/revenue/view_revenue'),
      name: 'ViewRevenue',
      hidden: true,
      type: ['revenue.viewRevenue'],
      meta: { title: '计划分月统计', icon: 'revenue', noCache: true }
    },
    {
      path: 'plan_revenue',
      component: () =>
        import('@/views/revenue/plan_revenue'),
      name: 'RevenuePlan',
      hidden: true,
      type: ['revenue.viewRevenue'],
      meta: { title: '计划管理', icon: 'revenue', noCache: true }
    }
    ]
  },

  // 收入 income.viewIncome  income.saveIncome income.updateIncome income.deleteIncome income.exportIncome income.invalidIncome
  {
    path: '/income',
    redirect: '/income/index',
    isChildren: false,
    component: Layout,
    hidden: false,
    meta: { title: '收入', icon: 'income', noCache: true },
    children: [{
      path: 'index',
      component: () =>
        import('@/views/income/index'),
      name: 'Income',
      hidden: false,
      type: ['income.viewIncome'],
      meta: { title: '收入', icon: 'income', noCache: true }
    },
    {
      path: 'edit_income',
      component: () =>
        import('@/views/income/edit_income'),
      name: 'EditIncome',
      hidden: true,
      type: ['income.saveIncome'],
      meta: { title: '收入管理', icon: 'income', noCache: true }
    }
    ]
  },

  // 预算 budget.viewBudget budget.saveBudget budget.updateBudget budget.deleteBudget budget.exportBudge
  {
    path: '/budget',
    redirect: '/budget/index',
    isChildren: false,
    component: Layout,
    hidden: false,
    meta: { title: '预算', icon: 'budget', noCache: true },
    children: [{
      path: 'index',
      component: () =>
        import('@/views/budget/index'),
      name: 'Budget',
      hidden: false,
      type: ['budget.viewBudget'],
      meta: { title: '预算', icon: 'budget', noCache: true }
    },
    {
      path: 'plan_budget',
      component: () =>
        import('@/views/budget/plan_budget'),
      name: 'BudgetPlan',
      hidden: true,
      type: ['budget.viewBudget'],
      meta: { title: '预算管理', icon: 'budget', noCache: true }
    },
    {
      path: 'view_budget',
      component: () =>
        import('@/views/budget/view_budget'),
      name: 'ViewBudget',
      hidden: false,
      type: ['budget.viewBudget'],
      meta: { title: '预算分月统计', icon: 'budget', noCache: true }
    }
    ]
  },

  // 支出 expense.viewExpense  expense.saveExpense expense.updateExpense expense.deleteExpense expense.exportExpense expense.invalidExpense
  {
    path: '/expense',
    redirect: '/expense/index',
    isChildren: false,
    component: Layout,
    hidden: false,
    meta: { title: '支出', icon: 'expense', noCache: true },
    children: [{
      path: 'index',
      component: () =>
        import('@/views/expense/index'),
      name: 'Expense',
      hidden: false,
      type: ['expense.viewExpense'],
      meta: { title: '支出', icon: 'expense', noCache: false }
    }
      // {
      //   path: 'edit_expense',
      //   component: () =>
      //     import('@/views/expense/edit_expense'),
      //   name: 'EditExpense',
      //   hidden: true,
      //   type: ['expense.saveExpense'],
      //   meta: { title: '支出管理', icon: 'expense', noCache: false }
      // }
    ]
  },

  // 利润表 profit.viewProfit  profit.saveProfit profit.updateProfit profit.deleteProfit profit.exportProfit
  {
    path: '/profit',
    redirect: '/profit/index',
    isChildren: false,
    component: Layout,
    hidden: false,
    meta: { title: '利润表', icon: 'profit', noCache: true },
    children: [{
      path: 'index',
      component: () =>
        import('@/views/profit/index'),
      name: 'Profit',
      hidden: false,
      type: ['profit.viewProfit'],
      meta: { title: '利润表', icon: 'profit', noCache: true }
    },
    {
      path: 'edit_profit',
      component: () =>
        import('@/views/profit/edit_profit'),
      name: 'EditProfit',
      hidden: true,
      type: ['profit.updateProfit'],
      meta: { title: '利润表配置', icon: 'expense', noCache: true }
    }
    ]
  },
  {
    path: '/supplier_management',
    redirect: '/supplier_management/index',
    isChildren: true,
    component: Layout,
    meta: { title: '供应商管理', icon: 'supplier', noCache: true },
    hidden: false,
    children: [{
      path: 'index',
      component: () => import('@/views/supplierManagement/supplier'),
      name: 'SupplierManagement',
      hidden: false,
      type: ['supplier.view'],
      meta: { title: '供应商', noCache: true }
    },
    {
      path: 'supplierOrder',
      component: () => import('@/views/supplierManagement/order'),
      name: 'SupplierOrder',
      hidden: false,
      type: ['supplier.goods'],
      meta: { title: '订单管理', noCache: true }
    }, {
      path: 'payment',
      component: () => import('@/views/supplierManagement/payment'),
      name: 'Payment',
      hidden: false,
      type: ['supplier.payment'],
      meta: { title: '货款明细', noCache: true }
    },
    {
      path: 'setting',
      component: () => import('@/views/supplierManagement/setting'),
      name: 'Setting',
      hidden: false,
      type: ['supplier.jurisdiction.view'],
      meta: { title: '设置', noCache: true }
    }]
  },
  // 账户资金管理 account.viewAccount account.saveAccount  account.updateAccount  account.deleteAccount
  {
    path: '/account_management',
    redirect: '/account_management/index',
    isChildren: false,
    component: Layout,
    meta: { title: '账户管理', icon: 'account_management', noCache: true },
    hidden: false,
    children: [{
      path: 'index',
      component: () =>
        import('@/views/account_management/index'),
      name: 'AccountManagement',
      hidden: false,
      type: ['account.viewAccount'],
      meta: {
        title: '账户资金管理',
        icon: 'account_management',
        noCache: true
      }
    }]
  },

  // 合同管理 contract.viewContract contract.saveContract contract.updateContract contract.deleteContract contract.invalidContract
  {
    path: '/contract',
    redirect: '/contract/index',
    isChildren: false,
    component: Layout,
    hidden: false,
    meta: { title: '合同管理', icon: 'contract', noCache: false },
    children: [{
      path: 'index',
      type: ['contract.viewContract'],
      hidden: false,
      name: 'Contract',
      component: () =>
        import('@/views/contract/index'),
      meta: { title: '合同管理', icon: 'contract', noCache: false }
    },
    {
      path: 'contract_template',
      type: ['contract.viewContract'],
      hidden: true,
      name: 'ContractTemplate',
      component: () =>
        import('@/views/contract/contract_template'),
      meta: { title: '合同模板管理', icon: 'contract', noCache: true }
    },
    {
      path: 'contract_detail',
      type: ['contract.viewContract'],
      hidden: true,
      name: 'ContractDetail',
      component: () =>
        import('@/views/contract/contract_detail'),
      meta: { title: '合同详情', icon: 'contract', noCache: true }
    },
    {
      path: 'contract_form',
      type: ['contract.viewContract'],
      hidden: true,
      name: 'ContractForm',
      component: () =>
        import('@/views/contract/contract_form'),
      meta: { title: '合同详情', icon: 'contract', noCache: true }
    }
    ]
  },

  // 账本管理 subarea.saveSubarea    subarea.updateRevenue
  {
    path: '/account_book',
    redirect: '/account_book/index',
    isChildren: false,
    component: Layout,
    hidden: true,
    meta: { title: '账本管理', icon: 'account_book', noCache: true },
    children: [{
      path: 'index',
      component: () =>
        import('@/views/account_book/index'),
      name: 'AccountBook',
      hidden: true,
      type: ['allow'],
      meta: { title: '账本管理', icon: 'account_book', noCache: true }
    }]
  },

  {
    path: '/addon-center',
    redirect: '/addon-center/index',
    isChildren: false,
    component: Layout,
    hidden: false,
    meta: { title: '应用中心', icon: 'application_new', noCache: true },
    children: [
      {
        path: 'index',
        component: () =>
          import('@/views/addon-center/index'),
        name: 'Addon',
        hidden: false,
        type: ['appcenter.view'],
        meta: { title: '应用中心', icon: 'application_new', noCache: true }
      },
      {
        path: 'invoice',
        component: () =>
          import('@/views/addon-center/invoice'),
        name: 'Invoice',
        hidden: true,
        type: ['appcenter.view'],
        meta: { title: '发票管理', icon: 'application_new', noCache: true }

        // beforeEnter: (to, from, next) => {
        //   const invoice_management = router.app.$options.store.getters.addonPermissions.filter(i => i.addonId === 1)

        //   if (invoice_management.length > 0) {
        //     if (invoice_management[0].isAdmin || invoice_management[0].scope) { next() } else {
        //       alert('权限不够，请联系管理员处理')
        //     }
        //   }
        // }
      },
      {
        path: 'company',
        component: () =>
          import('@/views/addon-center/company'),
        name: 'Company',
        hidden: true,
        type: ['company.viewCompanyContract'],
        meta: { title: 'CRM', icon: 'application_new', noCache: true }
      },
      {
        path: 'integral',
        component: () =>
          import('@/views/addon-center/integral'),
        name: 'Integral',
        hidden: true,
        type: ['appcenter.view'],
        meta: { title: '积分发票', icon: 'application_new', noCache: true }
      },
      {
        path: 'wxLogin',
        component: () =>
          import('@/views/addon-center/wxLogin'),
        name: 'WxLogin',
        hidden: true,
        type: ['appcenter.view'],
        meta: { title: '企业微信', icon: 'application_new', noCache: true }
      },
      {
        path: 'messagePush',
        component: () =>
          import('@/views/addon-center/messagePush'),
        name: 'MessagePush',
        hidden: true,
        type: ['appcenter.view'],
        meta: { title: '消息推送', icon: 'application_new', noCache: true }
      }
    ]
  },
  // 积分发票 integral.viewIntegral  integral.saveIntegral integral.updateIntegral integral.deleteIntegral integral.exportIntegral
  // {
  //   path: '/invoice',
  //   isChildren: false,
  //   redirect: '/invoice/index',
  //   component: Layout,
  //   hidden: false,
  //   meta: { title: '积分发票', icon: 'invoice', noCache: true },
  //   children: [{
  //     path: 'index',
  //     component: () =>
  //       import ('@/views/invoice/index'),
  //     name: 'Invoice',
  //     hidden: false,
  //     type: ['integral.viewIntegral'],
  //     meta: { title: '积分发票', icon: 'invoice', noCache: true }
  //   }]
  // },

  {
    path: '/systemManagement',
    redirect: '/systemManagement/index',
    isChildren: true,
    alwaysShow: false,
    component: Layout,
    hidden: false,
    meta: { title: '系统管理', icon: 'system', noCache: true },
    children: [
      {
        path: 'department_staff/index',
        component: () => import('@/views/department_staff/index'),
        name: 'DepartmentStaff',
        hidden: false,
        type: ['department.viewDepartment'],
        meta: { title: '部门员工', icon: 'department_staff', noCache: true }
      },
      // {
      //   path: 'department_staff/index',
      //   component: () => import('@/views/department_staff/index'),
      //   name: 'DepartmentStaff',
      //   hidden: false,
      //   type: ['department.viewDepartment'],
      //   meta: { title: '部门员工', icon: 'department_staff', noCache: true }
      // },
      {
        path: 'jurisdiction/index',
        component: () =>
          import('@/views/jurisdiction/index'),
        name: 'Jurisdiction',
        hidden: false,
        type: ['role.viewRole'],
        meta: { title: '角色权限', icon: 'jurisdiction', noCache: true }
      },
      {
        path: 'jurisdiction/edit_role',
        component: () =>
          import('@/views/jurisdiction/edit_role'),
        name: 'EditRole',
        hidden: true,
        type: ['role.saveRole'],
        meta: { title: '角色管理', icon: 'edit_role', noCache: true }
      },
      {
        path: 'order/index',
        component: () =>
          import('@/views/order/index'),
        name: 'Order',
        hidden: false,
        type: ['order.viewOrder'],
        meta: { title: '消费记录', icon: 'el-icon-s-order', noCache: true }
      },
      {
        path: 'logs/index',
        component: () =>
          import('@/views/logs/index'),
        name: 'Logs',
        hidden: false,
        type: ['log.viewLog'],
        meta: { title: '操作日志', icon: 'logs', noCache: true }
      },
      {
        path: 'system/index',
        component: () =>
          import('@/views/system/index'),
        name: 'System',
        hidden: false,
        type: ['config.viewConfig'],
        meta: { title: '系统设置', icon: 'system', noCache: true }
      }
    ]

  },

  // 部门员工 department.viewDepartment department.saveDepartment department.updateDepartment department.deleteDepartment
  // {
  //   path: '/department_staff',
  //   redirect: '/department_staff/index',
  //   isChildren: false,
  //   component: Layout,
  //   hidden: false,
  //   meta: { title: '部门员工', icon: 'department_staff', noCache: true },
  //   children: [{
  //     path: 'index',
  //     component: () =>
  //       import('@/views/department_staff/index'),
  //     name: 'DepartmentStaff',
  //     hidden: false,
  //     type: ['department.viewDepartment'],
  //     meta: { title: '部门员工', icon: 'department_staff', noCache: true }
  //   }]
  // },

  // 权限管理 role.viewRole role.saveRole role.updateRole role.deleteRole
  // {
  //   path: '/jurisdiction',
  //   redirect: '/jurisdiction/index',
  //   isChildren: false,
  //   component: Layout,
  //   meta: { title: '权限管理', icon: 'jurisdiction', noCache: true },
  //   hidden: false,
  //   children: [{
  //     path: 'index',
  //     component: () =>
  //       import('@/views/jurisdiction/index'),
  //     name: 'Jurisdiction',
  //     hidden: false,
  //     type: ['role.viewRole'],
  //     meta: { title: '角色', icon: 'jurisdiction', noCache: true }
  //   },
  //   {
  //     path: 'edit_role',
  //     component: () =>
  //       import('@/views/jurisdiction/edit_role'),
  //     name: 'EditRole',
  //     hidden: true,
  //     type: ['role.saveRole'],
  //     meta: { title: '角色管理', icon: 'edit_role', noCache: true }
  //   }
  //   ]
  // },

  // 操作日志 log.viewLog
  // {
  //   path: '/order',
  //   redirect: '/order/index',
  //   isChildren: false,
  //   component: Layout,
  //   hidden: false,
  //   meta: { title: '消费记录', icon: 'el-icon-s-order', noCache: true },
  //   children: [{
  //     path: 'index',
  //     component: () =>
  //       import('@/views/order/index'),
  //     name: 'Order',
  //     hidden: false,
  //     type: ['order.viewOrder'],
  //     meta: { title: '消费记录', icon: 'el-icon-s-order', noCache: true }
  //   }]
  // },

  // 操作日志 log.viewLog
  // {
  //   path: '/logs',
  //   redirect: '/logs/index',
  //   isChildren: false,
  //   component: Layout,
  //   hidden: false,
  //   meta: { title: '操作日志', icon: 'logs', noCache: true },
  //   children: [{
  //     path: 'index',
  //     component: () =>
  //       import('@/views/logs/index'),
  //     name: 'Logs',
  //     hidden: false,
  //     type: ['log.viewLog'],
  //     meta: { title: '操作日志', icon: 'logs', noCache: true }
  //   }]
  // },

  // 系统配置 system.viewSystem
  // {
  //   path: '/system',
  //   redirect: '/system/index',
  //   isChildren: false,
  //   component: Layout,
  //   meta: { title: '系统配置', icon: 'system', noCache: true },
  //   hidden: false,
  //   children: [{
  //     path: 'index',
  //     component: () =>
  //       import('@/views/system/index'),
  //     name: 'System',
  //     hidden: false,
  //     type: ['config.viewConfig'],
  //     meta: { title: '系统配置', icon: 'system', noCache: true }
  //   }]
  // },

  // 授权管理
  {
    path: '/external',
    redirect: '/external/index',
    isChildren: true,
    component: Layout,
    meta: { title: '外部数据', icon: 'el-icon-s-open', noCache: true },
    hidden: true,
    children: [{
      path: 'warrant',
      type: ['external.viewExternal'],
      hidden: false,
      name: 'Warrant',
      component: () =>
        import('@/views/external/warrant'),
      meta: { title: '授权管理', icon: 'contract', noCache: true }
    },
    {
      path: 'externalIncome',
      type: ['external.viewExternal'],
      hidden: false,
      name: 'ExternalIncome',
      component: () =>
        import('@/views/external/income'),
      meta: { title: '收入数据', icon: 'contract', noCache: true }
    },
    {
      path: 'externalExpense',
      type: ['external.viewExternal'],
      hidden: false,
      name: 'ExternalExpense',
      component: () =>
        import('@/views/external/expense'),
      meta: { title: '支出数据', icon: 'contract', noCache: true }
    }
    ]
  },

  {
    path: '/redirect',
    redirect: '/redirect/index',
    isChildren: false,
    component: Layout,
    meta: { title: '正在切换账本...', icon: 'redirect', noCache: true },
    hidden: true,
    children: [{
      path: 'index',
      type: ['allow'],
      hidden: true,
      component: () =>
        import('@/views/redirect/index'),
      meta: { title: '正在切换账本...', icon: 'redirect', noCache: true }
    }]
  },
  {
    path: '/other/redirect/:path(.*)',
    type: ['allow'],
    component: () =>
      import('@/views/other/redirect/index'),
    hidden: true,
    name: 'OtherRedirect'
  },

  // 新增路由要增加在 404 前面，不然会被下面的 * 拦截
  {
    path: '*',
    type: ['allow'],
    component: () =>
      import('@/views/error-page/404'),
    hidden: true
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

const whiteList = ['Login', 'RenovationOfferGetOffer']
const whiteListPath = ['/login']

router.beforeEach(async(to, from, next) => {
  const token = localStorage.getItem('token')
  const isWhiteList = whiteList.indexOf(to.name) !== -1 || whiteListPath.indexOf(to.path) !== -1
  if (token || isWhiteList) {
    return next()
  }

  next({
    path: '/login',
    query: {
      redirect: to.path,
      ...to.query
    }
  })
})
router.afterEach(() => { })

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
